const globalNotifications = {
  wentWrong: "Something went wrong!",
  noRecords: "No records found.",
  fetchingMessage: "Loading Data",
  updatedSuccessfully: "Successfully updated",
  createdSuccessfully: "Successfully Created",
  unExpectedError: "An unexpected error occurred",
  tryAgainMessage: "Something went wrong!.Try again..",
  roleChangeMessage: "Do you want to Change the Role?",
  loadingMessage: "Loading...",
  uploadError: "Someting went wrong while uploading",
  noUserMatchMessage: "No matching application user",
  userDeletedMessage: "User Deleted Successfully",
  warning: "Warning",
  unsavedChanges: "Unsaved Changes",
  discardMessage: "Are you sure you want to discard your changes?",
  dataNotFoundMessage: "Data not Found",
  noDatFound: "No data found",
  attributes: "Attributes",
  assignees: "Assignees",
  invalidNumber: "Please enter a valid number",
  minNumber: "Value must be at least {{minValue}}",
  maxNumber: "Value must be at least {{maxValue}}",
  filedRequired: "This field is required",
  sessionExpiredHeading: "Session Expired",
  sessionExpiredMessage:
    "Your session has expired. Redirecting to logout page in a few seconds...",
  successfullyLoggedOut: "You have logged out successfully.",
  errorWhileLogin:
    "Sorry, there was an error logging in. Please click Login to try again.",
  sessionExpiresSoon: "Your session expires soon!",
  extendSessionDescription1:
    "To keep your data safe, we will log you out of the application in {{time}}",
  extendSessionDescription2:
    "If you are still working, you can extend your session now. Otherwise, you will be logged out automatically.",
  pageNotFound: "Page Not Found",
  willDisappear: "This message will disappear in 5 seconds",
  willExpires: "Session expired. Logging out in 3 seconds.",
  tryRefershing: "Try refreshing the page or",
  goBackHome: "to go back to the home page.",
  noDataAvailable: "Data Not Available Now",
  accessDenied:
    "You don't have user access to view {{applicationHeading}}. Contact System Admin for access",
  copiedToClipboard: "Address has been copied to the clipboard.",
  copiedToClipboardError: "Failed to copy address",
  globalCopiedToClipboard: "{{labelName}} has been copied to the clipboard.",
  globalCopiedToClipboardError: "Failed to copy {{labelName}}",
  noCasePermission: "You do not have permission to view this case.",
  caseIdNotValid: "Case Id is not valid",
  noAttributesFound: "No attributes with value",
  numberOutOfRange: `Value must be between minValue and maxValue for the attributes: {{attributeName}}`,
  progressingMessage: `Status: {{status}}`,
  searchActivateCharacterLimit: "Note: Please enter atleast 3 characters to search for {{labelName}}",
};

export default globalNotifications;
